


// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Typography,
//   CircularProgress,
//   Card,
//   CardContent,
//   Grid,
//   TextField,
//   Button,
//   InputAdornment,
// } from "@mui/material";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchOTDetails } from "../actions/OTdetailsAction";
// import { useLocation } from "react-router-dom";
// import HeaderBannerPage from "../components/HeaderBannerPage";
// import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// import SearchIcon from "@mui/icons-material/Search";

// const OTDetails = () => {
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const { employeeId } = location.state || {};
//   const { OTList = [], loading: OTLoading } = useSelector(
//     (state) => state.otdetails || {}
//   );
//   const [openDatePicker, setOpenDatePicker] = useState(false);
//   const [selectedDate, setSelectedDate] = useState(new Date());
//   const [searchTerm, setSearchTerm] = useState("");

//   useEffect(() => {
//     const formattedDate = selectedDate.toISOString().split("T")[0]; // Format date to YYYY-MM-DD
//     dispatch(fetchOTDetails(formattedDate, employeeId));
//     //setSearchTerm(""); // Reset search bar when date changes
//   }, [dispatch, selectedDate, employeeId]);

//   // Filter OT list based on search term, but only from the already loaded data for the selected date
//   const filteredOTList = OTList.filter((job) => {
//     const serviceNo = job.serviceNo ? job.serviceNo.toString().toLowerCase().trim() : "";
//     const search = searchTerm.toLowerCase().trim();
//     return serviceNo.includes(search);
//   });

//   return (
//     <Box sx={{ padding: 0, maxWidth: "95%", margin: "0 auto" }}>
//       <HeaderBannerPage />



//           {/* Date Picker Button */}
//       <Box sx={{ textAlign: "center", mt: 0.5, mb: 1 }}>
//           <Button
//           variant="contained"
//           onClick={() => setOpenDatePicker(true)}
//           sx={{
//             borderRadius: "25px",
//             padding: "10px 20px",
//             backgroundColor: "#142c54",
//             color: "#fff",
//             fontWeight: "bold",
//             textTransform: "none",
//             "&:hover": {
//               backgroundColor: "#0D47A1",
//             },
//           }}
//         >
//           <CalendarTodayIcon sx={{ marginRight: "8px" }} />
//           Choose Date
//         </Button>
//       </Box>

//       {/* Date Picker */}
//       {openDatePicker && (
//         <Box sx={{ my: 2 }}>
//            <LocalizationProvider dateAdapter={AdapterDateFns}>
//            <DatePicker
//              label="Select Date"
//              value={selectedDate}
//              onChange={(newValue) => {
//               if (newValue) {
//               setSelectedDate(newValue);
//               setOpenDatePicker(false);
//               } // Close the DatePicker after selecting a date
//              }}
//              renderInput={(params) => <TextField {...params} fullWidth />}
//               open={openDatePicker}
//               onClose={() => setOpenDatePicker(false)}
//             />
//           </LocalizationProvider>
//         </Box>
//       )}

//       {/* Date Picker Button */}
//       {/* <Box sx={{ textAlign: "center", mt: 0.5, mb: 1 }}>
//         <LocalizationProvider dateAdapter={AdapterDateFns}>
//           <DatePicker
//             label="Select Date"
//             value={selectedDate}
//             onChange={(newValue) => setSelectedDate(newValue)}
//             renderInput={(params) => <TextField {...params} fullWidth />}
//           />
//         </LocalizationProvider>
//       </Box> */}

//       {/* Search Bar */}
//       <Box sx={{ my: 2 }}>
//         <TextField
//           fullWidth
//           label="Search by Service Number"
//           variant="outlined"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//           InputProps={{
//             startAdornment: (
//               <InputAdornment position="start">
//                 <SearchIcon sx={{ color: "#154C79" }} />
//               </InputAdornment>
//             ),
//           }}
//           sx={{
//             fontSize: { xs: "0.85rem", sm: "1rem" },
//             color: "#154C79",
//             borderRadius: "20px",
//             "& .MuiOutlinedInput-root": { borderRadius: "20px" },
//             "& .MuiOutlinedInput-notchedOutline": { borderColor: "#154C79" },
//           }}
//         />
//       </Box>

//       {/* OT List */}
//       <Box sx={{ maxHeight: "480px", overflowY: "auto" }}>
//         {OTLoading ? (
//           <Box sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
//             <CircularProgress />
//           </Box>
//         ) : filteredOTList.length > 0 ? (
//           filteredOTList.map((job) => (
//             <Card
//               key={job.iwNo}
//               sx={{
//                 mb: 2,
//                 borderRadius: 3,
//                 boxShadow: 3,
//                 border: "1px solid #ccc",
//                 backgroundColor: job.actualouttime < job.outtime ? "#FFCCCC" : "#E8F5E9",
//               }}
//             >
//               <CardContent sx={{ padding: "8px" }}>
//                 <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
//                   <Typography fontWeight="bold">{job.empName}</Typography>
//                   <img
//                     src={`https://esystems.cdl.lk/backend-test/AttendMe2/Home/GetDTSUserImg?serviceNo=${job.serviceNo}`}
//                     alt={job.EmpName}
//                     style={{
//                       width: "70px",
//                       height: "70px",
//                       borderRadius: "50%",
//                       objectFit: "cover",
//                       border: "2px solid #ddd",
//                     }}
//                     onError={(e) => (e.target.src = "/placeholder-image.jpg")}
//                   />
//                 </Box>
//                 <Grid container spacing={0.4}>
//                   <Grid item xs={5}><Typography variant="body2" fontWeight="bold">Service Number:</Typography></Grid>
//                   <Grid item xs={5}><Typography variant="body2">{job.serviceNo}</Typography></Grid>
//                   <Grid item xs={5}><Typography variant="body2" fontWeight="bold">Supervisor:</Typography></Grid>
//                   <Grid item xs={5}><Typography variant="body2">{job.supervisorname}</Typography></Grid>
//                   <Grid item xs={5}><Typography variant="body2" fontWeight="bold">Location:</Typography></Grid>
//                   <Grid item xs={5}><Typography variant="body2">{job.supervisorloc}</Typography></Grid>
//                   <Grid item xs={5}><Typography variant="body2" fontWeight="bold">Shift Time:</Typography></Grid>
//                   <Grid item xs={5}><Typography variant="body2">{job.intime} - {job.outtime}</Typography></Grid>
//                   <Grid item xs={5}><Typography variant="body2" fontWeight="bold">Actual Out Time:</Typography></Grid>
//                   <Grid item xs={5}><Typography variant="body2">{job.actualouttime}</Typography></Grid>
//                   <Grid item xs={5}><Typography variant="body2" fontWeight="bold">Slot Type:</Typography></Grid>
//                   <Grid item xs={5}><Typography variant="body2">{job.slotType}</Typography></Grid>
//                   <Grid item xs={5}><Typography variant="body2" fontWeight="bold">Job:</Typography></Grid>
//                   <Grid item xs={5}><Typography variant="body2">{job.jobDescription}</Typography></Grid>
//                 </Grid>
//               </CardContent>
//             </Card>
//           ))
//         ) : (
//           <Typography variant="body1" sx={{ textAlign: "center", padding: "20px" }}>
//             No overtime jobs found.
//           </Typography>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default OTDetails;



import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  CircularProgress,
  Card,
  CardContent,
  Grid,
  TextField,
  Button,
  InputAdornment,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useDispatch, useSelector } from "react-redux";
import { fetchOTDetails } from "../actions/OTdetailsAction";
import { useLocation } from "react-router-dom";
import HeaderBannerPage from "../components/HeaderBannerPage";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import SearchIcon from "@mui/icons-material/Search";

const OTDetails = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { employeeId } = location.state || {};
  const { OTList = [], loading: OTLoading } = useSelector(
    (state) => state.otdetails || {}
  );

  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const formattedDate = selectedDate.toISOString().split("T")[0]; // Format date to YYYY-MM-DD
    dispatch(fetchOTDetails(formattedDate, employeeId));
  }, [dispatch, selectedDate, employeeId]);

  // Filter OT list based on search term
  const filteredOTList = OTList.filter((job) => {
    const serviceNo = job.serviceNo ? job.serviceNo.toString().toLowerCase().trim() : "";
    const search = searchTerm.toLowerCase().trim();
    return serviceNo.includes(search);
  });

  return (
    <Box sx={{ padding: 0, maxWidth: "95%", margin: "0 auto" }}>
      <HeaderBannerPage />

      {/* Date Picker Button */}
      <Box sx={{ textAlign: "center", mt: 0.5, mb: 1 }}>
        <Button
          variant="contained"
          onClick={() => setOpenDatePicker(true)}
          sx={{
            borderRadius: "25px",
            padding: "10px 20px",
            backgroundColor: "#142c54",
            color: "#fff",
            fontWeight: "bold",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "#0D47A1",
            },
          }}
        >
          <CalendarTodayIcon sx={{ marginRight: "8px" }} />
          Choose Date
        </Button>
      </Box>

      {/* Date Picker */}
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        {openDatePicker && (
          <Box sx={{ my: 2 }}>
            <DatePicker
              label="Select Date"
              value={selectedDate}
              onChange={(newValue) => {
                setSelectedDate(newValue);
                setOpenDatePicker(false);
              }}
              renderInput={(params) => <TextField {...params} fullWidth />}
              open={openDatePicker}
              onClose={() => setOpenDatePicker(false)}
            />
          </Box>
        )}
      </LocalizationProvider>

      {/* Search Bar */}
      <Box sx={{ my: 2 }}>
        <TextField
          fullWidth
          label="Search by Service Number"
          variant="outlined"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: "#154C79" }} />
              </InputAdornment>
            ),
          }}
          sx={{
            fontSize: { xs: "0.85rem", sm: "1rem" },
            color: "#154C79",
            borderRadius: "20px",
            "& .MuiOutlinedInput-root": { borderRadius: "20px" },
            "& .MuiOutlinedInput-notchedOutline": { borderColor: "#154C79" },
          }}
        />
      </Box>

      {/* OT List */}
      <Box sx={{ maxHeight: "480px", overflowY: "auto" }}>
        {OTLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
            <CircularProgress />
          </Box>
        ) : filteredOTList.length > 0 ? (
          filteredOTList.map((job) => (
            <Card
              key={job.iwNo}
              sx={{
                mb: 2,
                borderRadius: 3,
                boxShadow: 3,
                border: "1px solid #ccc",
                backgroundColor: job.actualouttime < job.outtime ? "#FFCCCC" : "#E8F5E9",
              }}
            >
              <CardContent sx={{ padding: "8px" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
                  <Typography fontWeight="bold">{job.empName}</Typography>
                  <img
                    src={`https://esystems.cdl.lk/backend/AttendMe2/Home/GetDTSUserImg?serviceNo=${job.serviceNo}`}
                    alt={job.empName}
                    style={{
                      width: "70px",
                      height: "70px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      border: "2px solid #ddd",
                    }}
                    onError={(e) => (e.target.src = "/placeholder-image.jpg")}
                  />
                </Box>
                <Grid container spacing={0.4}>
                  <Grid item xs={5}><Typography variant="body2" fontWeight="bold">Service Number:</Typography></Grid>
                  <Grid item xs={5}><Typography variant="body2">{job.serviceNo}</Typography></Grid>
                  <Grid item xs={5}><Typography variant="body2" fontWeight="bold">Supervisor:</Typography></Grid>
                  <Grid item xs={5}><Typography variant="body2">{job.supervisorname}</Typography></Grid>
                  <Grid item xs={5}><Typography variant="body2" fontWeight="bold">Location:</Typography></Grid>
                  <Grid item xs={5}><Typography variant="body2">{job.supervisorloc}</Typography></Grid>
                  <Grid item xs={5}><Typography variant="body2" fontWeight="bold">Shift Time:</Typography></Grid>
                  <Grid item xs={5}><Typography variant="body2">{job.intime} - {job.outtime}</Typography></Grid>
                  <Grid item xs={5}><Typography variant="body2" fontWeight="bold">Actual Out Time:</Typography></Grid>
                  <Grid item xs={5}><Typography variant="body2">{job.actualouttime}</Typography></Grid>
                  <Grid item xs={5}><Typography variant="body2" fontWeight="bold">Slot Type:</Typography></Grid>
                  <Grid item xs={5}><Typography variant="body2">{job.slotType}</Typography></Grid>
                  <Grid item xs={5}><Typography variant="body2" fontWeight="bold">Job:</Typography></Grid>
                  <Grid item xs={5}><Typography variant="body2">{job.jobDescription}</Typography></Grid>
                </Grid>
              </CardContent>
            </Card>
          ))
        ) : (
          <Typography variant="body1" sx={{ textAlign: "center", padding: "20px" }}>
            No overtime jobs found.
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default OTDetails;
